import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay,EffectCoverflow,Navigation,Pagination,Scrollbar,A11y } from 'swiper/modules';
import Card from './Card';
import 'swiper/css';

import { Link } from 'react-router-dom';
import ImageBox from './ImageBox';
const SpliderImage = ({image,images}) => {
    const [toggler, setToggler] = useState(false);
    const [slide, setSlide] = useState(0);
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const [imageArr, setImageArr] = useState([]);
    const PaginationRef = useRef(null);
    const open_image_box=(idx)=>{
        setToggler(!toggler);
        setSlide(idx);
    }
     useEffect(()=>{
      
      if(images){
        let imgs=[image];
        images.map((image)=>{
          imgs.push(image.images)
        })
        setImageArr(imgs);
      }      
     
    },[image,images])
    return (

    <div className=''> 
      
      <ImageBox  images={imageArr} slide={slide} toggler={toggler} />
      {imageArr.length>1&&(
      <Swiper 
       
      ref={PaginationRef} 
      spaceBetween={50}
      
        slidesPerView='auto'
   
        speed={200}
        className='d-flex justify-content-center flex-wrap gap-3 mb-5'
     
        >
          
        </Swiper>
      )}
      <div className='image-swiper'>
        {imageArr.length>1&&(
          <div className="button-image-swiper">
          <i className='fa-solid fa-chevron-right ' ref={prevRef}></i>
          <i className='fa-solid fa-chevron-left ' ref={nextRef}></i>
        </div>
        )}
       
      <Swiper style={{ width:'100%',borderRadius:'20px' }}
        modules={[Autoplay,EffectCoverflow,Navigation,Pagination,A11y,Scrollbar]}    
        // autoplay={{
        //   delay: 6000,
        //   disableOnInteraction: false,
        //   reverseDirection : false,
        //   delayBetweenSlides: 0,
        //   paused:false
        // }}
         
        spaceBetween={20}
        slidesPerGroup={1}
  
        speed={200}
      
        loop={true}
        slidesPerView={1}
        centeredSlides={true}  
      
        navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }}
        pagination={{ 
          el:PaginationRef.current,
          clickable: true ,
          direction: 'horizontal',
          horizontalClass: 'my-horizontal-swiper',
          renderBullet: (index, className) => {
            return '<SwiperSlide class="' + className + '"><img src="'+imageArr[index]+'" ></SwiperSlide>' ;
          },
          type:'bullets'
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.params.pagination.el = PaginationRef.current;
     }}
      >
         
           {imageArr.map((img,idx)=>(
          <SwiperSlide key={idx}  style={{display:'flex',justifyContent:'center'}}>
                <img className="image-product-select" onClick={()=>open_image_box(idx)} src={img} alt="Card image cap" />
           </SwiperSlide>
      ))} 
        
      </Swiper>  
      </div>
    
    
     
    </div>
    
      );
}

export default SpliderImage